<template>
  <div class="status-class-info-log"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="classTeacherLogGroups">
      <AppScrollbar v-if="classTeacherLogGroups && classTeacherLogGroups.length"
                    style="height: 100%">
        <div class="log-main">
          <el-timeline>
            <el-timeline-item v-for="classTeacherLogGroup in classTeacherLogGroups"
                              :key="classTeacherLogGroup.name"
                              :timestamp="classTeacherLogGroup.opDate"
                              placement="top">
              <div class="item-list">
                <div v-for="item in classTeacherLogGroup.items"
                     :key="item.id"
                     class="item">
                  <el-tag size="mini"
                          :type="item.op | opType">{{item.op | opName}}</el-tag>
                  <span class="class-teacher">{{item.classTeacher}}</span>
                </div>
              </div>
              <div class="operator">操作人：{{classTeacherLogGroup.operator}}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </AppScrollbar>
      <Hint v-else>
        <div>没有调整记录</div>
      </Hint>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>调整记录加载失败</div>
        <el-button type="text"
                   @click="loadClassTeacherSetLog">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'StatusClassInfoLog',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      classTeacherSetLogs: false
    }
  },
  filters: {
    opName (val) {
      if (val === '1') {
        return '新增班主任'
      } else if (val === '0') {
        return '删除班主任'
      } else {
        return '未知操作'
      }
    },
    opType (val) {
      if (val === '1') {
        return 'success'
      } else if (val === '0') {
        return 'danger'
      } else {
        return 'warning'
      }
    }
  },
  computed: {
    classTeacherLogGroups () {
      let classTeacherSetLogs = this.classTeacherSetLogs
      if (classTeacherSetLogs) {
        let groups = []
        let lastGroup
        classTeacherSetLogs.forEach(log => {
          let groupName = `${log.opDate}_${log.operator}`
          if (lastGroup && lastGroup.name === groupName) {
            lastGroup.items.push(log)
          } else {
            lastGroup = {
              name: groupName,
              opDate: log.opDate,
              operator: log.operator,
              items: [log]
            }
            groups.push(lastGroup)
          }
        })
        return groups
      }
    }
  },
  methods: {
    loadClassTeacherSetLog () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/clazz/info/classTeacherSetLog',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.classTeacherSetLogs = response.data['classTeacherSetLogs'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadClassTeacherSetLog()
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.loadClassTeacherSetLog()
      }
    }
  }
}
</script>

<style lang="scss">
  .status-class-info-log {
    height: 360px;
    .log-main {
      padding: 15px;
      .el-timeline {
        padding-left: 0;
        .el-timeline-item {
          .el-timeline-item__wrapper {
            .el-timeline-item__timestamp {
              color: #606266;
              font-size: 12px;
              font-weight: bold;
            }
            .el-timeline-item__content {
              .item-list {
                margin-top: 10px;
                padding: 12px;
                background-color: #fff;
                border-radius: 5px;
                box-shadow: 0 1px 5px rgba(0,0,0,.1);
                & > .item {
                  font-size: 12px;
                  .class-teacher {
                    margin-left: 5px;
                    color: #606266;
                    &:empty {
                      &:before {
                        content: '\002d\002d';
                        color: #909399;
                      }
                    }
                  }
                  & + .item {
                    margin-top: 8px;
                  }
                }
              }
              .operator {
                margin-top: 5px;
                color: #909399;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
</style>
